import Croppie from 'croppie';

export default class AvatarCrop {
	constructor(uploadControl) {
		if (!uploadControl) return false;
		this.initialLoad = true;
		this.uploadControl = uploadControl;
		this.container = document.getElementById('avatarUpload');
		this.currentAvatarContainer = document.getElementById('currentAvatar');
		this.wrapper = document.createElement('DIV');
		this.wrapper.setAttribute('class', 'upload__wrapper');
		this.preview = document.createElement('DIV');
		this.preview.setAttribute('id', 'upload__preview');
		this.input = document.createElement('INPUT');
		this.input.setAttribute('name', 'picture');
		this.input.setAttribute('type', 'hidden');

		this.wrapper.appendChild(this.preview);
		this.wrapper.appendChild(this.input);

		this.uploadControl.addEventListener('change', (e) => {
			this.container.insertBefore(this.wrapper, this.container.firstChild);
			const opts = {
				viewport: {
					width: 100,
					height: 100,
					type: 'circle',
				},
				enableExif: true,
			};
			if (this.currentAvatarContainer != null) this.currentAvatarContainer.innerHTML = '';
			if (this.initialLoad) this.uploadControl = new Croppie(this.preview, opts);
			this.readFile(e.target);
		});
		window.addEventListener('save-succesful', () => {
			if (this.uploadControl && this.wrapper && this.input.value) {
				this.uploadControl.destroy();
				this.wrapper.remove();
				this.currentAvatarContainer.innerHTML = `<img src="${this.input.value}" class="avatar avatar--bordered avatar--big" >`;
			}
		});
	}

	readFile(input) {
		if (input.files && input.files[0]) {
			const reader = new FileReader();
			reader.onload = (e) => {
				this.bindImage(e.target.result);
			};
			reader.readAsDataURL(input.files[0]);
		}
	}

	bindImage(image) {
		this.uploadControl
			.bind({
				url: image,
			})
			.then(() => {
				this.updateInput();
				this.initialLoad = false;
				this.preview.addEventListener('update', () => {
					this.updateInput();
				});
			});
	}

	updateInput() {
		this.uploadControl
			.result({ type: 'base64', size: { width: 400, height: 400 }, circle: false })
			.then((x) => {
				this.input.setAttribute('value', x);
			});
	}
}
